export default "__VITE_ASSET__DDnnr0Ev__"